import {
  AgreementContentBlockType,
  IAgreementContentBlock,
} from '../../../redux/api/agreements/interfaces';

export function splitAgreementLeadBlocks(blocks: IAgreementContentBlock[]) {
  const firstTitleIdx = blocks.findIndex(
    (b) => b.type === AgreementContentBlockType.TITLE,
  );
  const firstParaAfterTitleIdx =
    firstTitleIdx >= 0
      ? blocks.findIndex(
          (b, i) =>
            i > firstTitleIdx && b.type === AgreementContentBlockType.PARAGRAPH,
        )
      : -1;

  if (firstTitleIdx < 0) {
    return {
      beforeLead: [] as IAgreementContentBlock[],
      leadTitle: null as IAgreementContentBlock | null,
      leadParagraph: null as IAgreementContentBlock | null,
      afterLead: blocks,
    };
  }

  const beforeLead = firstTitleIdx > 0 ? blocks.slice(0, firstTitleIdx) : [];
  const leadTitle = blocks[firstTitleIdx];
  const leadParagraph =
    firstParaAfterTitleIdx >= 0 ? blocks[firstParaAfterTitleIdx] : null;
  const afterLeadStart =
    firstParaAfterTitleIdx >= 0
      ? firstParaAfterTitleIdx + 1
      : firstTitleIdx + 1;
  const afterLead = blocks.slice(afterLeadStart);

  return { beforeLead, leadTitle, leadParagraph, afterLead };
}
